import { Box, Button, Text } from 'grommet';

export type SegmentedControlProps<T extends string> = {
  options: { label: string; value: T }[];
  value: T;
  onChange: (value: T) => void;
  a11yTitle: string;
  disabled?: boolean;
};

/** One of a few choices, side by side: Draft | Final, Week | Month | Quarter */
export function SegmentedControl<T extends string>(props: SegmentedControlProps<T>) {
  const { options, value, onChange, a11yTitle, disabled } = props;
  return (
    <Box
      direction="row"
      role="radiogroup"
      aria-label={a11yTitle}
      border={{ color: 'border-input' }}
      round="8px"
      overflow="hidden"
      flex={false}
    >
      {options.map((option, i) => {
        const selected = option.value === value;
        return (
          <Button
            key={option.value}
            plain
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => !selected && onChange(option.value)}
          >
            <Box
              pad={{ vertical: '6px', horizontal: '14px' }}
              background={selected ? 'brand' : 'white'}
              border={i > 0 ? { side: 'left', color: 'border-input' } : undefined}
            >
              <Text size="small" weight={600} color={selected ? 'white' : 'text-secondary'}>
                {option.label}
              </Text>
            </Box>
          </Button>
        );
      })}
    </Box>
  );
}
